import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { AddRoleData } from '../models/add-role-data';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-role-view',
    styleUrls: ['./add-role-view.component.scss'],
    templateUrl: './add-role-view.component.html',
    standalone: false
})
export class AddRoleViewComponent {
   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<AddRoleData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: FormGroup;

   @Input() accountId: number | null;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
